import React from 'react';
import {noop} from 'lodash';

type AutocompleteListBoxContextType = {
  activeOptionNote: string | null;
  notePortalRef?: React.RefObject<HTMLDivElement | null>;
  setActiveOptionNote: React.Dispatch<React.SetStateAction<string | null>>;
  setNoteHeight: React.Dispatch<React.SetStateAction<number>>;
};

export const AutocompleteListBoxContext =
  React.createContext<AutocompleteListBoxContextType>({
    activeOptionNote: null,
    setActiveOptionNote: noop,
    setNoteHeight: noop,
  });

export const useAutocompleteListBoxContext =
  (): AutocompleteListBoxContextType => {
    const context = React.useContext(AutocompleteListBoxContext);
    const isTestEnvironment = process.env.NODE_ENV === 'test';

    if (!context && !isTestEnvironment) {
      throw new Error(
        'You must use component within AutocompleteListBox Context'
      );
    }

    return context;
  };
